import React from "react";
import { useTranslation } from "react-i18next";
import { getBlogImage } from "../../constants/images";
import { HiArrowRight } from "react-icons/hi";

const Card = ({ blog }) => {
  const { t } = useTranslation();
  const blogImage = getBlogImage(blog.image);

  return (
    <article className="flex flex-col h-full">
      <div className="overflow-hidden bg-paper-tint aspect-[4/3] mb-5">
        <img
          src={blogImage}
          alt={t(blog.title_one)}
          loading="lazy"
          className="img-editorial"
        />
      </div>

      <div className="flex items-baseline gap-3 border-t border-[color:var(--rule)] pt-3">
        <span className="label tabular">{blog.date}</span>
        <span className="label text-gold-ink">{t("Article")}</span>
      </div>

      <h3 className="display-3 mt-3">{t(blog.title_one)}</h3>

      <p className="mt-3 text-[0.9375rem] leading-relaxed text-ink-soft line-clamp-3 flex-1">
        {t(blog.desc_one)}
      </p>

      <span className="link-underline text-sm font-medium mt-5 self-start">
        {t("Read More")}
        <HiArrowRight aria-hidden className="text-sm transition-transform duration-200 group-hover:translate-x-1" />
      </span>
    </article>
  );
};

export default Card;
